import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const SimRow = ({ children, innerRef, className, color, id }) => {
  return (
    <Fragment>
      <style className='hidden'>
        {`
          #row_${id}::before {
            box-shadow: 3px 0px 0 0 ${color};
          }
        `}
      </style>
      <tr
        ref={ innerRef }
        className={ `glg-table-row ${ className || '' }` }
        id={ `row_${id}` }
      >
        <Fragment>
          {React.Children.map(children, (child, _index) => {
            if (!child) {
              return null
            }

            return (
              <td title={ typeof child.props.children === 'string' && child.props.children }>
                { React.cloneElement(child, child.props, child.props.children) }
              </td>
            )
          })}
        </Fragment>
      </tr>
    </Fragment>
  )
}

SimRow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  innerRef: PropTypes.string,
  color: PropTypes.string,
  id: PropTypes.string,
}

export default SimRow